<template>
  <div>
    <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
      <span>{{message}}</span>
    </v-snackbar>
    <v-alert
      v-model="alert"
      border="left"
      close-text="Chiudi"
      color="warning"
      dark
      dismissible
    >
      Attenzione! Se disattivate uno slot, le relative prenotazioni non saranno più visibili (ma non cancellate)
    </v-alert>    
    <v-card class="neu-glow mb-3">
      <v-card-title primary-title  class="pb-0">
        <div class="text-h5">Slots Attivi</div>
        <v-spacer></v-spacer>
        <v-div class="mr-1">
          <!--
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" :disabled="allSlots_hash==JSON.stringify(allSlots)"  @click.stop="saveActiveSlots()">
                <v-icon color="error">mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>-->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                <v-icon color="info">mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span>Istruzioni</span>
          </v-tooltip>                
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click.stop="getData()">
                <v-icon color="info">mdi-sync-circle</v-icon>
              </v-btn>
            </template>
            <span>Refresh</span>
          </v-tooltip>                                     
        </v-div> 
      </v-card-title>
      <v-row v-if="!allSlots">
          <v-col class="text-center px-4">
            <v-progress-linear
              color="info"
              height="10"
              indeterminate
              striped
            ></v-progress-linear>
          </v-col>
      </v-row>
      <v-row v-else class="px-8 py-5">
        <v-sheet class="neu-glow">

          <v-tabs
            color="info"
            elevation="8"
            v-model="shiftId"
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            show-arrows
          >
            <v-tabs-slider color="info"></v-tabs-slider>
            <template v-for="(s,si) in allShifts" >
              <v-tab
                :key=si
                :href="'#'+s.shiftId"
                class="font-weight-bold"
              >
                {{s.text}}
              </v-tab>
              <v-tab-item :key=s :id="s.shiftId" class="mt-3 mx-4 mb-4 neu-glow pt-2">
                <v-row class="mt-1 pb-3">

                  <v-col cols="3" sm="2" md="1" :key="sli" class="text-center" v-for="(sl,sli) in allSlots">
                    <v-btn @click="echo(sl,sli,shiftId)" :small="$vuetify.breakpoint.xsOnly" max-height="32"  elevation="5" class="my-n1" :disabled="sl.shiftId&&sl.shiftId!=s.shiftId" :class="sl.shiftId==s.shiftId?'info white--text':''">
                      <span v-html="sl.slotName"></span>
                    </v-btn>
                  </v-col>

                </v-row>
              </v-tab-item>
            </template>
          </v-tabs>

        </v-sheet>

      </v-row>
    </v-card>
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              Istruzioni
                <v-spacer></v-spacer>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                        <v-icon color="info">mdi-close</v-icon>
                    </v-btn>
                    </template>
                    <span>Esci</span>
                </v-tooltip>             
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5">
              <v-col md="6" cols="12">
                <p>
                  Gli "Slots" sono gli orari che volete rendere prenotabili.
                </p>
                <p>
                  Per ogni turno creato nella pagina precedente e selezionabile tramite i pulsanti presenti sotto "Slot Attivi", selezionate gli slot che volete utilizzare.
                </p>
              </v-col>
              <v-col md="6" cols="12">
                <p>
                  Il pulsante 'Salva' si attiva qualora rilevi differenze rispetto ai dati memorizzati.
                </p>
                <p>
                  Dopo il salvataggio i dati vengono automaticamente ricaricati: qualora notaste delle incongruenze, prima di fare ulteriori modifiche cliccare sul tasto 'Refresh'
                </p>
              </v-col>
              <v-col cols="12">
                <p color="error">
                    
                </p>
              </v-col>
            </v-row>
        </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
//import _ from 'lodash'
export default {
  data() {
    return {
      page: "Settings",
      loading:false,
      loading_update:false,
      dialog_instruction:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      allSlots:null,
      allShifts:null,
      clockStep:null,
      allSlots_hash:null,
      tabs:[],
      shiftId:null,
      fltSlots2:null,
      alert:true,
    };
  },
  computed : {
    ...mapGetters(["user"])
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    }
  },
  methods:
  {
    echo(sl,sli)
    {
      //console.log(174,this.shiftId,sl,sli)
      //console.log(175,this.allSlots.find(s=>s.slotId=slotId))
      //console.log(193,this.allSlots,JSON.stringify(this.allSlots))
      //this.allSlots.find(s=>s.slotId=slotId).shiftId=this.shiftId;
      if(this.allSlots[sli].shiftId)
      {
        this.allSlots[sli].shiftId=null;
        this.allSlots[sli].active=!this.allSlots[sli].active;
      }
      else
      {
        this.allSlots[sli].shiftId=this.shiftId;
      }
      //console.log(195,this.allSlots,JSON.stringify(this.allSlots))
      this.saveActiveSlot(sl)
    },
    async saveActiveSlot(sl)
    {
        this.loading_update=true;
        //console.log(255,this.allSlots);
        sl.shiftId=this.shiftId;
        let payload={"action":"saveItem","table":"Slot","payload":{"slot":sl}};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.allSlots_hash=JSON.stringify(this.allSlots);
            this.snackbar = true;
            this.getData();
        }   
    },
async saveActiveSlots()
    {
        this.loading_update=true;
        console.log(255,this.allSlots);
        let payload={"action":"saveItem","table":"AllSlots","payload":{"slots":this.allSlots.filter(s=>s.shiftId)}};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.allSlots_hash=JSON.stringify(this.allSlots);
            this.snackbar = true;
            this.getData();
        }   
    },
    async getData()
    {
        {
            this.loading=true;
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllSlots_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading= false;
                switch (res.data.errorid)
                {
                  case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.allShifts=res.data.payloads.allShifts;
                    this.allSlots=res.data.payloads.allSlots;
                    this.allSlots_hash=JSON.stringify(this.allSlots);
                    //this.tabs=res.data.allSlots.map(item => item.clockStep).filter((value, index, self) => self.indexOf(value) === index)
                    console.log(282,this.allShifts,this.allSlots)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },    

    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(333);
                //this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
          console.log(e);
          this.loading= false;
          this.dialog_connection_error=true;
        }
    }
  },
};
</script>